import type { ComponentPropsWithRef } from "react";

import { cn } from "@intergamma/common/cn";

export function ChevronDown({
  className,
  ...props
}: ComponentPropsWithRef<"svg">) {
  return (
    <>
      <svg
        className={cn("karwei:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M6.29289 11.0518L12 16.7589L17.7071 11.0518C18.0976 10.6613 18.0976 10.0281 17.7071 9.63762C17.3166 9.2471 16.6834 9.2471 16.2929 9.63762L12 13.9305L7.70711 9.63762C7.31658 9.2471 6.68342 9.2471 6.29289 9.63762C5.90237 10.0281 5.90237 10.6613 6.29289 11.0518Z"
          fill="currentColor"
        />
      </svg>
      <svg
        className={cn("gamma:hidden", className)}
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1283 16.1232L5.08726 9.21375L5.78766 8.50001L12.1216 14.7156L18.3339 8.50333L19.041 9.21043L12.1283 16.1232Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}
